import { useEffect, useState } from "react";
import MaxWidthContainer from "../Components/Layouts/MaxWidthContainer/MaxWidthContainer";
import {
  Box,
  Button,
  Grid,
  GridItem,
  Input,
  Text,
  Radio,
  RadioGroup,
  Flex,
  Image,
  Link,
  HStack,
  VStack,
} from "@chakra-ui/react";

import {
  Slider,
  SliderTrack,
  SliderFilledTrack,
  SliderThumb,
  SliderMark,
} from "@chakra-ui/react";

import {
  addDoc,
  collection,
  getDocs,
  query,
  where,
} from "@firebase/firestore";

import { firestore } from "../firebase";
import { useToastWrapper } from "../Wrapper/toastWrapper";
import Loader from "../Components/Common/Loader";
import { AdminAPI } from "../Apis/adminAPI";
import CheckIcon from "../Assets/icons/check";
import { FaTwitter, FaFacebook, FaLinkedin } from "react-icons/fa";
import { useParams } from 'react-router-dom';
import data from "../data.json";
import data1 from "../data/data1.json";
import data2 from "../data/data2.json";
import data3 from "../data/data3.json";
import data4 from "../data/data4.json";

type Props = {};

const Home = (props: Props) => {
  const [sliderValue, setSliderValue] = useState(50);

  const [loading, setLoading] = useState(false);
  const { success, error } = useToastWrapper();

  const [inputs, setInputs] = useState<any>([]);

  // Get domain from route params
  const { domain } = useParams();

  // Backup method to get domain from window.location
  const currentDomain = domain || window.location.hostname.replace('www.', '');

  // Add domain mapping with proper typing
  const domainToDataMap: { [key: string]: any } = {
    '': data,
    'mspcosts': data1,
    'instantmsppricing': data2,
    'pricemyhelpdesk': data3,
    'mymanagedservicepricing': data4,
  };

  // Use the mapped data or fall back to default data
  const siteData = domainToDataMap[currentDomain.split('.')[0]] || data;

  useEffect(() => {
    console.log('Current domain:', currentDomain);
    console.log('Using data for:', currentDomain.split('.')[0]);
  }, [currentDomain]);

  // Add new state to track if form is submitted
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);



  const submitForm = async (testdata: any) => {
    if (!testdata.name || !testdata.phone || !testdata.email) {
      return error("Please fill all the fields");
    }

    if (testdata.phone.length < 10) {
      return error("Phone number should be at least 10 digits long");
    }

    if (!testdata.email.includes("@")) {
      return error("Invalid email address");
    }

    let data = {
      ...testdata,
      date: new Date().toISOString(),
      domain: currentDomain, // Add the current domain
    };

    try {
      setLoading(true);

      const googleSheetURL =
        "https://script.google.com/macros/s/AKfycbwk3zCzesS_O7QAO9xyfWo8ZBL8vYgIXC3Kz6V80fxbYOSRssjuJd7gEPda1dlQS6tSLA/exec";

      const response = await fetch(googleSheetURL, {
        method: "POST",
        mode: "no-cors",
        headers: {
          "Content-Type": "text/plain",
        },
        body: JSON.stringify(data),
      });

      success("Request submitted successfully! We will contact you soon.");
      setInputData({
        name: "",
        phone: "",
        email: "",
        additionalInfo: "",
      });
      setIsFormSubmitted(true);
    } catch (err) {
      console.log("Error submitting form:", err);
      error("Failed to submit the form. Please try again.");
    } finally {
      setLoading(false);
    }
  };




  const getInputValues = async () => {
    const ref = collection(firestore, "inputs");

    const newquery: any = query(ref, where("deleted", "!=", true));

    try {
      setLoading(true);
      const docSnap: any = await getDocs(newquery);

      if (docSnap.docs.length > 0) {
        let localDoc = [];
        for (const doc of docSnap.docs) {
          localDoc.push(doc.data());
        }
        localDoc.map((item: any) => {
          if (item?.type === "slider") {
            item.value = 30;
          } else if (item?.type === "radio") {
            item.value = item.options[0].multiplier;
          } else if (item?.type === "input") {
            item.value = 0;
          }
        });
        setInputs(localDoc);
      }
    } catch (err: any) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getInputValues();
  }, []);

  const [calculatedPrice, setCalculatedPrice] = useState<any>(0);

  const calculatePrice = () => {
    let tempPrice: number = 0;

    inputs.map((item: any) => {
      if (item?.type === "slider" && item?.value) {
        tempPrice +=
          (Number(item?.value) / 100) *
          (Number(item?.max) - Number(item?.min)) *
          Number(item.multiplier);
      } else if (item?.type === "input" && item?.value) {
        tempPrice += Number(item?.value) * Number(item?.multiplier);
      } else if (item?.type === "radio") {
        tempPrice += Number(item?.value);
      }
    });

    setCalculatedPrice(tempPrice);
  };

  useEffect(() => {
    console.log("calculating price");
    calculatePrice();
  }, [inputs]);

  const [inputData, setInputData] = useState({
    name: "",
    phone: "",
    email: "",
    additionalInfo: "",
  });

  return (
    <Box minHeight={"100vh"} display={"flex"} flexDirection={"column"}>
      {loading && <Loader />}

      {/* Section 1 */}
      <Box
        display={"flex"}
        backgroundImage={`url('${siteData.banner}')`}
        backgroundSize={"cover"}
        w={"100%"}
        minH={"90vh"}
        flexDirection={"column"}
        color={"white"}
        position={"relative"}
      >
        <Box
          position={"absolute"}
          top={0}
          left={0}
          w={"100%"}
          h={"100%"}
          bg={"rgba(0, 0, 0, 0.4)"}
          backdropFilter={"blur(5px)"}
        />

        <MaxWidthContainer>
          {/* Navbar */}
          <HStack
            borderBottom={"2px solid rgba(255, 255, 255, 0.2)"}
            py={6}
            px={12}
            justifyContent={"space-between"}
          >
            <Text fontSize={"2xl"} fontWeight={600} letterSpacing={"2px"}>
              {siteData.logo}
            </Text>

            <Flex gap={6}>
              {siteData.links.map((link: string, index: number) => (
                <Link key={index} fontWeight={500} _hover={{ color: "#47B2FF" }}>
                  {link}
                </Link>
              ))}
            </Flex>
          </HStack>

          {/* Main Section */}
          <Box minHeight="75vh" display="flex" justifyContent="center" alignItems="center">
            <Flex mt={10} gap={"20px"} align={"center"}>
              {/* Left Side - Brand Introduction */}
              <Box w={"50%"} display={"flex"} flexDirection={"column"} alignItems={"start"}>
                <Text fontSize={"6xl"} fontWeight={700} lineHeight={"1.2"}>
                  {siteData.title.split(" ").map((word: string, i: number) => (
                    <span key={i} style={{ color: i === 2 ? "#47B2FF" : "inherit" }}>{word} </span>
                  ))}
                </Text>
                <Text fontSize={"xl"} fontWeight={400} mt={4} textAlign={"start"} opacity={0.8}>
                  {siteData.subtitle}
                </Text>
              </Box>

              {/* Right Side - Pricing Section */}
              <Box w={"50%"} display={"flex"} alignItems={"center"} justifyContent={"center"}>
                <Box
                  width={"500px"}
                  padding={"40px"}
                  bg={"rgba(255, 255, 255, 0.1)"}
                  backdropFilter={"blur(15px)"}
                  borderRadius={"20px"}
                  border={"1px solid rgba(255, 255, 255, 0.2)"}
                >
                  <Text fontSize={"4xl"} fontWeight={700} color={"#fff"}>
                    {siteData.pricingTitle}
                  </Text>
                  <Text fontSize={"2xl"} fontWeight={400} opacity={0.8} color={"#ddd"}>
                    {siteData.pricingSubtitle}
                  </Text>
                  <Text mt={4} textAlign={"justify"} fontSize={"md"} fontWeight={500} opacity={0.9} color={"#ccc"}>
                    {siteData.pricingDescription}
                  </Text>

                  <Button
                    mt={7}
                    py={6}
                    px={7}
                    bg={siteData.ctaButton.background}
                    borderRadius={"35px"}
                    _hover={{ bg: siteData.ctaButton.hoverBackground }}
                    color={siteData.ctaButton.textColor}
                    fontSize={"lg"}
                    onClick={() => {
                      window.scrollTo({
                        top: 1220,
                        behavior: "smooth"
                      });
                    }}
                  >
                    {siteData.ctaButton.text}
                  </Button>
                </Box>
              </Box>
            </Flex>
          </Box>

        </MaxWidthContainer>
      </Box>


      {/* Section 2 */}
      <Box flex={1}>
        <Flex mt={"120px"} align={"center"} justify={"center"} flexDirection={"column"}>
          <Text fontSize={"4xl"} fontWeight={600} textAlign={"center"}>
            {siteData.whyChooseTitle}
          </Text>
          <Flex mt={8} gap={8} flexWrap={"wrap"} justify={"center"}>
            {siteData.whyChooseFeatures.map((feature: any, index: number) => (
              <Box
                key={index}
                maxW={"320px"}
                p={6}
                borderRadius={"20px"}
                textAlign={"center"}
                bg={"rgba(255, 255, 255, 0.1)"}
                backdropFilter={"blur(10px)"}
                boxShadow={"0 4px 15px rgba(71, 178, 255, 0.3)"}
                border={"1.5px solid rgba(255, 255, 255, 0.2)"}
                borderColor={"#3174a5"}
              >
                <Text fontSize={"3xl"}>{feature.icon}</Text>
                <Text fontSize={"2xl"} fontWeight={600} mt={3}>
                  {feature.title}
                </Text>
                <Text fontSize={"md"} opacity={0.8} mt={2}>
                  {feature.desc}
                </Text>
              </Box>
            ))}
          </Flex>
        </Flex>
        <MaxWidthContainer>
          <>
            <Box
              mx={"20px"}
              mt={"120px"}
              overflow={"hidden"}
              display={"flex"}
              flexDirection={"column"}
              alignItems={"center"}
              justifyContent={"center"}
              position={"relative"}
            >
              <Box position={"relative"}>
                <Text fontSize={"4xl"} fontWeight={600}>
                  {siteData.instantPricingTitle}
                </Text>
              </Box>
              <Text fontSize={"lg"} mt={"10px"} fontWeight={400}>
                {siteData.instantPricingSubtitle}
              </Text>

              <Box
                display={"flex"}
                flexDirection={["column", "row"]}
                py={"30px"}
                gap={"100px"}
              >
                <Box px={"10px"} flex={1} minW={"50%"}>
                  {inputs.map((input: any, index: number) => {
                    return (
                      <RenderInput
                        input={input}
                        setInputs={setInputs}
                        inputs={inputs}
                        index={index}
                      />
                    );
                  })}
                </Box>
                <Box mx={"auto"} width={["90%", "500px"]}>
                  <Box
                    bg={"#3174A5"}
                    w={"100%"}
                    shadow={"md"}
                    display={"flex"}
                    flexDirection={"column"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    borderRadius={"30px"}
                    px={"20px"}
                    py={"40px"}
                  >
                    <Text
                      w={"300px"}
                      textAlign={"center"}
                      fontSize={"4xl"}
                      color={"white"}
                      fontWeight={500}
                    >
                      {siteData.pricingBoxTitle}
                    </Text>

                    {isFormSubmitted ? (
                      <Box
                        mt={"60px"}
                        textAlign={"center"}
                        display={"flex"}
                        flexDirection={"column"}
                        justifyContent={"center"}
                      >
                        <HStack>
                          <CheckIcon />
                          <Text fontSize={"5xl"} color={"white"} fontWeight={700}>
                            $ {calculatedPrice?.toFixed(0) || 0}
                          </Text>
                        </HStack>

                        <Text
                          mt={"10px"}
                          fontSize={"2xl"}
                          fontWeight={500}
                          color={"white"}
                        >
                          {siteData.pricingPeriod}
                        </Text>
                      </Box>
                    ) : (
                      <Text
                        mt={"20px"}
                        fontSize={"xl"}
                        color={"white"}
                        textAlign={"center"}
                      >
                        Please fill out the form below to see your customized pricing
                      </Text>
                    )}
                  </Box>
                  <Grid
                    templateColumns={{ base: "1fr", md: "1fr 1fr" }}
                    gap={"20px"}
                    mt={"30px"}
                    w={"80%"}
                    margin={"auto"}
                    py={"50px"}
                  >
                    <GridItem colSpan={2}>
                      <Box
                        display={"flex"}
                        gap={"5px"}
                        flexDirection={"column"}
                      >
                        <Text
                          fontSize={"md"}
                          color={"#3174A5"}
                          fontWeight={500}
                        >
                          Name
                        </Text>
                        <Input
                          placeholder=""
                          size="sm"
                          border={"1px solid #3174A5"}
                          backgroundColor={"#F5F5F5"}
                          borderRadius={"10px"}
                          value={inputData.name}
                          onChange={(e) =>
                            setInputData({
                              ...inputData,
                              name: e.target.value,
                            })
                          }
                        />
                      </Box>
                    </GridItem>

                    <GridItem colSpan={2}>
                      <Box
                        display={"flex"}
                        gap={"5px"}
                        flexDirection={"column"}
                      >
                        <Text
                          color={"#3174A5"}
                          fontSize={"md"}
                          fontWeight={500}
                        >
                          Phone
                        </Text>
                        <Input
                          type="number"
                          placeholder=""
                          size="sm"
                          border={"1px solid #3174A5"}
                          backgroundColor={"#F5F5F5"}
                          borderRadius={"10px"}
                          value={inputData.phone}
                          onChange={(e) =>
                            setInputData({
                              ...inputData,
                              phone: e.target.value,
                            })
                          }
                        />
                      </Box>
                    </GridItem>

                    <GridItem colSpan={2}>
                      <Box
                        display={"flex"}
                        gap={"5px"}
                        flexDirection={"column"}
                      >
                        <Text
                          fontSize={"md"}
                          color={"#3174A5"}
                          fontWeight={500}
                        >
                          Email
                        </Text>
                        <Input
                          placeholder=""
                          size="sm"
                          border={"1px solid #3174A5"}
                          backgroundColor={"#F5F5F5"}
                          borderRadius={"10px"}
                          value={inputData.email}
                          onChange={(e) =>
                            setInputData({
                              ...inputData,
                              email: e.target.value,
                            })
                          }
                        />
                      </Box>
                    </GridItem>

                    <GridItem display={"flex"} colSpan={2}>
                      <Button
                        mt={7}
                        py={6}
                        px={7}
                        bg={"#47B2FF"}
                        borderRadius={"35px"}
                        _hover={{ bg: "#3396E0" }}
                        color={"#fff"}
                        fontSize={"lg"}
                        mx={"auto"}
                        onClick={() => submitForm(inputData)}
                      >
                        {siteData.ctaButton.text}
                      </Button>
                    </GridItem>
                  </Grid>
                </Box>
              </Box>
            </Box>
          </>
        </MaxWidthContainer>
      </Box>

      {/* Footer */}
      <Box shadow="md" bg="#3174A5" py="60px" color="white">
        <Box maxW="1200px" mx="auto" px="20px">
          <Flex
            direction={{ base: "column", md: "row" }}
            align="center"
            justify="space-between"
            gap={8}
          >
            {/* Logo and Company Info */}
            <VStack align="start" spacing={2}>
              <Image
                src="https://support305.com/wp-content/uploads/2022/05/Support305_HomePage_v2_03.png"
                alt="logo"
                w={200}
              />
              <Text fontSize="sm" maxW="300px">
                {siteData.footerDescription}
              </Text>
            </VStack>

            {/* Quick Links */}
            <VStack align="start" spacing={2}>
              <Text fontSize="md" fontWeight="bold">
                {siteData.footerQuickLinksTitle}
              </Text>
              <Link href="#" fontSize="sm" _hover={{ textDecoration: "underline" }}>
                {siteData.footerQuickLinksLinks[0]}
              </Link>
              <Link href="#" fontSize="sm" _hover={{ textDecoration: "underline" }}>
                {siteData.footerQuickLinksLinks[1]}
              </Link>
              <Link href="#" fontSize="sm" _hover={{ textDecoration: "underline" }}>
                {siteData.footerQuickLinksLinks[2]}
              </Link>
              {/* <Link href="#" fontSize="sm" _hover={{ textDecoration: "underline" }}>
                Careers
              </Link> */}
            </VStack>

            {/* Social Media */}
            <VStack align="start" spacing={2}>
              <Text fontSize="md" fontWeight="bold">
                Follow Us
              </Text>
              <Flex gap={4}>
                <Link href="#" isExternal>
                  <FaTwitter size={24} color="white" />
                </Link>
                <Link href="#" isExternal>
                  <FaFacebook size={24} color="white" />
                </Link>
                <Link href="#" isExternal>
                  <FaLinkedin size={24} color="white" />
                </Link>
              </Flex>
            </VStack>
          </Flex>

          {/* Copyright */}
          <Text fontSize="xs" textAlign="center" mt={8} borderTop={"1px solid white"} pt={4}>
            © {new Date().getFullYear()} {siteData.footerCopyright} All rights reserved.
          </Text>
        </Box>
      </Box>
    </Box>
  );
};

const RenderInput = ({ input, index, setInputs, inputs }: any) => {
  if (input.type === "input") {
    return (
      <Box mt={"15px"} display={"flex"} flexDirection={"column"} gap={"5px"}>
        <Text fontSize={"md"} color={"gray.500"} fontWeight={500}>
          {input.label}
        </Text>
        <Input
          type={"number"}
          placeholder={input.label}
          value={input?.value}
          onChange={(e: any) => {
            const tempInputs = [...inputs];
            tempInputs[index].value = e.target.value;
            setInputs(tempInputs);
          }}
          size="sm"
          borderRadius={"5px"}
        />
      </Box>
    );
  }

  if (input.type === "slider") {
    return (
      <Flex
        border="2px solid #3174A5"
        borderRadius={"20px"}
        p={"30px"}
        my={"15px"}
      >
        <Box w={"25%"}>
          <Image src={input.icon} alt="icon" w={"80px"} h={"80px"} />
        </Box>
        <Box flex={1} display={"flex"} gap={"20px"} flexDirection={"column"}>
          <Text
            fontSize={"md"}
            textAlign={"center"}
            color={"black"}
            fontWeight={500}
            dangerouslySetInnerHTML={{ __html: input.label }}
          ></Text>
          <Slider
            w={"100%"}
            step={(input.max - input.min) / 4}
            defaultValue={30}
            colorScheme="blue"
            onChange={(val: number) => {
              const tempInputs = [...inputs];
              tempInputs[index].value = parseInt(Number(val).toFixed(0));
              setInputs(tempInputs);
            }}
            value={parseInt(input?.value)}
          >
            <SliderMark mt={2} value={0} fontWeight={400} fontSize={"sm"}>
              {input?.min}
            </SliderMark>
            <SliderMark
              mt={2}
              value={100}
              ml={-4}
              fontWeight={400}
              fontSize={"sm"}
            >
              {input?.max}
            </SliderMark>
            <SliderMark
              value={input?.value}
              textAlign="center"
              bg="#3174A5"
              color="white"
              mt="-10"
              ml="-3"
              w="fit-content"
              p={"5px"}
              rounded={"md"}
            >
              <Text fontSize={"sm"} color={"white"} fontWeight={500}>
                {input?.value * ((input?.max - input?.min) / 100)}
              </Text>
            </SliderMark>
            <SliderTrack bg="gray.300">
              <SliderFilledTrack />
            </SliderTrack>
            <SliderThumb />
          </Slider>
        </Box>
      </Flex>
    );
  }

  if (input.type === "radio") {
    const handleRadioChange = (value: string) => {
      console.log(value);
      const tempInputs = [...inputs];
      tempInputs[index].value = Number(value);
      setInputs(tempInputs);
    };
    return (
      <Box mt={"15px"} display={"flex"} flexDirection={"column"} gap={"5px"}>
        {/* <Text fontSize={"md"} color={"gray.500"} fontWeight={500}>
          {input.label}
        </Text> */}
        <RadioGroup
          colorScheme="blue"
          onChange={handleRadioChange}
          value={input?.value}
        >
          <HStack mt={"10px"}>
            {input.options.map((option: any, index: number) => (
              <Radio
                display={"flex"}
                p={"30px"}
                gap={"20px"}
                flexDirection={"column"}
                key={index}
                value={option.multiplier}
              >
                <Text
                  textAlign={"center"}
                  fontSize={"sm"}
                  color={"gray.800"}
                  fontWeight={500}
                >
                  {option.label}
                </Text>
              </Radio>
            ))}
          </HStack>
        </RadioGroup>
      </Box>
    );
  }

  return null;
};

export default Home;
